import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import StoreBrands from "./StoreBrands.js";
const StoreBrandContainer = ({ brands }) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      title: getLabel("stores.page.details.brands.title")
    }),
    [getLabel]
  );
  return /* @__PURE__ */ React.createElement(StoreBrands, { labels, brands });
};
export {
  StoreBrandContainer as default
};
//# sourceMappingURL=StoreBrandsContainer.js.map
